module.exports = __webpack_public_path__ + "img/construct.2973fba2.png";